<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">系统</Breadcrumb-item>
        <Breadcrumb-item>管理员列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="70" :show-message="false" label-position="left">
        <Row :gutter="32">
          <i-col :xs="24" :sm="12" :md="6" :lg="6">
            <Form-item label="昵称" prop="nickname" :label-width="40">
              <Input placeholder="模糊" name="nickname" v-model="queryParam.nickname"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="6" :lg="6">
            <Form-item label="登录账号" prop="mobile">
              <Input placeholder="模糊" name="mobile" v-model="queryParam.mobile"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="6" :lg="6">
            <Form-item label="联系电话" prop="phone">
              <Input placeholder="模糊" name="phone" v-model="queryParam.phone"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="6" :lg="6">
            <Form-item label="分组" prop="groupId">
              <Select v-model.number="queryParam.groupId" filterable transfer>
                <Option v-for="item in adminGroupList" :value="item.id" :key="item.id">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <div class="left-btn">
        <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                @click="search">搜索
        </Button>
      </div>
      <div class="right-btn">
        <Button type="primary" icon="plus-round"
                @click="onEdit('')">添加管理员
        </Button>
        <Button type="primary" :loading="syncLoading" :disable="syncLoading" icon="refresh"
                @click="syncDingtalkName">同步钉钉名称
        </Button>
        <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="export"
                @click="exportData">绑定次数导出
        </Button>
      </div>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/adminUser/list"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
    <Modal title="编辑" v-model="showAdminUserEditModal">
      <Form ref="form" class="form" :model="editAdminUser" :rules="ruleAdminUser" :label-width="80">
        <Row>
          <i-col :span="22">
            <Form-item label="昵称" prop="nickname">
              <Input v-model="editAdminUser.nickname"></Input>
            </Form-item>
          </i-col>
          <i-col :span="22">
            <Form-item label="密码" prop="password">
              <Input placeholder="修改密码填写" v-model="editAdminUser.password"></Input>
            </Form-item>
          </i-col>
          <i-col :span="22">
            <Form-item label="登录账号" prop="mobile">
              <Input v-model="editAdminUser.mobile"></Input>
            </Form-item>
          </i-col>
          <i-col :span="22">
            <Form-item label="联系号码" prop="phone">
              <Input v-model="editAdminUser.phone" placeholder="用于bops 后台登录接收验证码"></Input>
            </Form-item>
          </i-col>
          <i-col :span="22">
            <Form-item label="钉钉手机号" prop="dingMobile">
              <Input v-model="editAdminUser.dingMobile"></Input>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="状态" prop="status">
              <Select v-model.number="editAdminUser.status" transfer>
                <Option v-for="item in statusList" :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="分组" prop="groupId">
              <Select v-model.number="editAdminUser.groupId" filterable transfer>
                <Option v-for="item in adminGroupList" :value="item.id" :key="item.id">{{ item.title }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="钉钉部门">
              <Select v-model.number="editAdminUser.dingtalkDepartmentId" @on-change="loadDingtalkUser"
                      placeholder="请选择" filterable transfer>
                <Option v-for="item in departmentList" :value="item.departmentId" :key="item.departmentId">
                  {{ item.departmentName }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="钉钉用户">
              <Select v-model="editAdminUser.dingtalkUserid" filterable transfer>
                <Option v-for="item in userList" :value="item.userId" :key="item.userId">{{ item.userName }}</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="是否接收钉钉消息" prop="isReceiveMsg">
              <Select v-model.number="editAdminUser.isReceiveMsg" filterable transfer>
                <Option value="0">否</Option>
                <Option value="1">是</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="工号">
              <Input
                v-model="editAdminUser.agentMoor" placeholder="EC 手机号"></Input>
            </Form-item>
          </i-col>

          <div v-if="editAdminUser.groupId === 10">
            <i-col :span="11">
              <Form-item label="所属小组" prop="teamType">
                <Select v-model.number="editAdminUser.teamType" transfer>
                  <Option v-for="item in $constant.adviserGroup" :key="item.code" :value="item.code">{{
                      item.text
                    }}
                  </Option>
                </Select>
              </Form-item>
            </i-col>
            <i-col :span="11">
              <Form-item label="职位" prop="positionType">
                <Select v-model.number="editAdminUser.positionType" transfer>
                  <Option value="1">普通组员</Option>
                  <Option value="2">小组长</Option>
                  <Option value="9">部门经理</Option>
                </Select>
              </Form-item>
            </i-col>
          </div>
          <i-col :span="11">
            <Form-item label="绑定老师限制(个)">
              <Input
                v-model="editAdminUser.adminConfig.limitBindTchNum"></Input>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="绑定时间限制(个)">
              <Input
                v-model="editAdminUser.adminConfig.limitBindTimeNum"></Input>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="绑定次数限制(次/月)">
              <Input
                v-model="editAdminUser.adminConfig.limitBindTimesMonth"></Input>
            </Form-item>
          </i-col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showAdminUserEditModal=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingEdit" @click="edit">保存</Button>
      </div>
    </Modal>

    <Modal title="编辑权限" v-model="editPermissionModal">
      <el-tree ref="permissionTree" :data="permissionData" show-checkbox class="permission-tree" :check-strictly="true"
               node-key="id" :default-checked-keys="checkKeys"></el-tree>
      <div slot="footer">
        <Button type="text" size="large" @click="editPermissionModal=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingEdit" @click="editPermission">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import AdminUserMultSelect from '../common/AdminUserMultSelect.vue'
import dates from '@/tools/date/dates.js'

export default {
  components: {AdminUserMultSelect},
  data () {
    let $constant = this.$constant
    return {
      searchLoading: false,
      exportLoading: false,
      syncLoading: false,
      reload: 0,
      checkKeys: [],
      queryParam: {
        nickname: '',
        mobile: '',
        phone: ''
      },
      statusList: $constant.enabledStatus,
      adminGroupList: null,
      departmentList: null,
      userList: null,
      loadingEdit: false,
      showAdminUserEditModal: false,
      editAdminUser: {
        id: null,
        password: '',
        nickname: '',
        mobile: '',
        phone: '',
        dingMobile: '',
        status: '',
        groupId: '',
        agentMoor: '',
        teamType: '',
        positionType: '',
        dingtalkUserid: '',
        isReceiveMsg: '',
        dingtalkDepartmentId: '',
        adminConfig: {
          limitBindTchNum: '',
          limitBindTimeNum: '',
          limitBindTimesMonth: '',
        }
      },
      ruleAdminUser: {
        nickname: [
          {type: 'string', required: true, message: '昵称不能为空', trigger: 'blur'},
          {type: 'string', max: 20, message: '登录账号不能超过20个字', trigger: 'blur'}
        ],
        mobile: [
          {type: 'string', required: true, message: '登录账号不能为空', trigger: 'blur'},
          {type: 'string', max: 30, message: '登录账号不能超过30个字', trigger: 'blur'}
        ],
        phone: [
          {type: 'string', required: true, message: '联系号码不能为空', trigger: 'blur'}
        ],
        groupId: [
          {type: 'integer', required: true, message: '请选择分组', trigger: 'blur'}
        ]
      },
      editPermissionModal: false,
      permissionData: [],
      title: [
        {
          title: 'id',
          // width: 100,
          align: 'center',
          key: 'id'
        },
        {
          title: '昵称',
          align: 'center',
          key: 'nickname'
        },
        {
          title: '登录账号',
          align: 'center',
          key: 'mobile'
        },
        {
          title: '联系电话',
          // width: 130,
          align: 'center',
          key: 'phone'
        },
        {
          title: '分组',
          // width: 130,
          align: 'center',
          key: 'groupTitle'
        },
        {
          title: '钉钉名称',
          align: 'center',
          key: 'dingtalkName'
        },
        {
          title: '绑定老师权限',
          // width: 130,
          align: 'center',
          key: 'limitMonthTimes'
        },
        {
          title: '最近登录时间',
          // width: 130,
          align: 'center',
          key: 'lastLoginTime'
        },
        {
          title: '登录IP',
          // width: 130,
          align: 'center',
          key: 'lastLoginIp'
        },
        {
          title: '操作',
          // width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('a', {
                on: {
                  click: () => {
                    this.onEdit(params.row.id)
                  }
                }
              }, '编辑'),
              h('span', {class: 'divider'}),
              h('a', {
                on: {
                  click: () => {
                    this.onEditPermission(params.row)
                  }
                }
              }, '权限管理')
            ])
          }
        }
      ]
    }
  },
  mounted: function () {
    this.loadAdminGroup()
  },
  created: function () {
  },
  methods: {
    exportData () {
      this.exportLoading = true
      this.$http.get('/adminUser/list-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '每月绑定老师次数统计.xlsx'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    syncDingtalkName () {
      let self = this
      self.syncLoading = true
      self.$http.post('/adminUser/syncDingtalkName', {}).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('同步成功，已更新' + (res.data || 0) + '条')
          self.search()
        }
        self.syncLoading = false
      }).catch(function () {
        self.syncLoading = false
      })
    },
    onEdit (id) {
      let self = this
      self.loadAdminGroup()
      self.loadDingTalkGroup()
      self.clearEditAdminUser()
      if (id) {
        self.$http.get('/adminUser/queryById?id=' + id).then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.editAdminUser = Object.assign({}, res.data)
          if (res.data.positionType) {
            self.editAdminUser.positionType = res.data.positionType + ''
          }
          if (res.data.dingtalkUserid) {
            self.editAdminUser.dingtalkUserid = res.data.dingtalkUserid + ''
          }
          if (res.data.isReceiveMsg) {
            self.editAdminUser.isReceiveMsg = res.data.isReceiveMsg + ''
          }
          if (res.data.dingtalkDepartmentId) {
            self.editAdminUser.dingtalkDepartmentId = res.data.dingtalkDepartmentId + ''
            self.loadDingtalkUser(res.data.dingtalkDepartmentId)
          }
          self.editAdminUser.adminConfig = res.data.adminConfig
          self.showAdminUserEditModal = true
        })
      } else {
        self.showAdminUserEditModal = true
      }
    },
    edit () {
      let self = this
      self.loadingEdit = true
      self.$refs.form.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingEdit = false
          return
        }
        let path = '/adminUser/update'
        if (!this.editAdminUser.id || this.editAdminUser.id === '') {
          path = '/adminUser/insert'
        }
        let data = Object.assign({}, self.editAdminUser)
        if (!data.dingtalkUserid) {
          data.dingtalkName = ''
        } else {
          let dingUser = (self.userList || []).find(item => String(item.userId) === String(data.dingtalkUserid))
          if (dingUser) {
            data.dingtalkName = dingUser.userName
          } else {
            delete data.dingtalkName
          }
        }
        self.$http.post(path, data).then(function (res) {
          if (res && res.data > 0) {
            self.showAdminUserEditModal = false
            self.$Message.success('提交成功!')
            self.search()
          }
          self.loadingEdit = false
        })
      })
    },
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    loadAdminGroup () {
      let self = this
      if (self.adminGroupList) {
        return
      }
      self.$http.get('/adminGroup/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.adminGroupList = res.data
      })
    },
    loadDingTalkGroup () {
      let self = this
      self.$http.get('/dingTalk/departmentList').then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.departmentList = res.data
      })
    },
    loadDingtalkUser (val) {
      let self = this
      if (val) {
        self.$http.get('/dingTalk/getUserListByDepartmentId?departmentId=' + val).then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.userList = res.data
        })
      }
    },
    clearEditAdminUser () {
      this.editAdminUser = {
        id: null,
        password: '',
        nickname: '',
        mobile: '',
        phone: '',
        dingMobile: '',
        status: '',
        groupId: '',
        dingtalkDepartmentId: '',
        dingtalkUserid: '',
        isReceiveMsg: '',
        adminConfig: {}
      }
    },
    editPermission () {
      let permissions = this.$refs.permissionTree.getCheckedNodes().map(item => item.id).join(',')

      this.loadingEdit = true
      let path = '/adminRuleExtend/saveAdminGroupExtend'

      this.$http.post(path, {uid: this.permissionGroupId, extendId: permissions}).then(res => {
        if (res && res.data > 0) {
          this.editPermissionModal = false
          this.$Message.success('提交成功!')
        }
        this.loadingEdit = false
      })
    },
    onEditPermission (row) {
      this.checkKeys = []
      if (!row || !row.id) {
        return
      }
      this.permissionGroupId = row.id
      this.$http.get('/adminRule/queryAdminRuleDetailByParam', {
        params: {
          type: 'adminUser',
          objectId: row.id
        }
      }).then(res => {
        if (!res || !res.data) {
          return
        }
        this.permissionData = res.data.map(item => {
          return this.treeNode(item)
        })

        this.editPermissionModal = true
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.$refs.permissionTree) {
              this.$refs.permissionTree.setCheckedKeys(this.checkKeys)
            }
          })
        })
      })
    },
    addCheckKeys (permissionDto) {
      if (permissionDto) {
        if (permissionDto.havePermission) {
          this.checkKeys.push(permissionDto.id)
        }
      }
    },
    treeNode (permissionDto) {
      if (!permissionDto) {
        return
      }
      this.addCheckKeys(permissionDto)
      let treeNode = {
        id: permissionDto.id,
        label: permissionDto.title,
        expand: true,
        checked: permissionDto.havePermission,
        children: []
      }
      if (permissionDto.childAdminRuleDtoList) {
        treeNode.children = permissionDto.childAdminRuleDtoList.map(item => {
          return this.treeNode(item)
        })
      }

      return treeNode
    },
  }
}

</script>

<style lang="less" scoped>
.btn-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 12px;
}

.left-btn {
  float: left;
}

.right-btn {
  float: right;
}
</style>



// WEBPACK FOOTER //
// AdminUserList.vue?e362e07a